const getUnleashConfig = ({
  appName = '',
  apiUrl = '',
  refreshInterval = 60,
  clientKey = '',
}: {
  appName?: string;
  apiUrl?: string;
  refreshInterval?: number;
  clientKey?: string;
}) => {
  const unleashUrl = `${apiUrl}`;

  return {
    url: unleashUrl,
    clientKey,
    refreshInterval,
    appName,
  };
};

export { getUnleashConfig };
